import IFormWithMedicalConditionsFilter from "../../../models/misconfig/bromcom/FormWithMedicalConditionsFilter";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { usePermissionCheck } from "../../../app/common/helper/Permissions";
import { Permissions } from "../../../app/enums";

interface IMedicalConditionsFilterEditProps extends IFormWithMedicalConditionsFilter {
    firstCol?: number;
    secondCol?: number;
}

export default function MedicalConditionsFilterEdit(props: IMedicalConditionsFilterEditProps) {
    const canEditEstablishments = usePermissionCheck(Permissions.CanEditEstablishments);
    const firstCol = props.firstCol ?? 2;
    const secondCol = props.secondCol ?? 4;

    const updateMedicalValue = (index: number, type: string, value: string) => {
        if(type === 'DN') {
            const updatedDN = [...props.medicalConditionsFilter?.DietaryNeeds || []];
            updatedDN[index] = value;
            props.setMedicalConditionsFilter({
                DietaryNeeds: updatedDN,
                DietaryPreferences: props.medicalConditionsFilter?.DietaryPreferences || []
            });
            return;
        } else if(type === 'DP') {
            const updatedDP = [...props.medicalConditionsFilter?.DietaryPreferences || []];
            updatedDP[index] = value;   
            props.setMedicalConditionsFilter({
                DietaryNeeds: props.medicalConditionsFilter?.DietaryNeeds || [],
                DietaryPreferences: updatedDP
            });
            return;
        }
    }

    const removeMedicalCondition = (index: number, type: string) => {
        if(type === 'DN') {
            const updatedDN = props.medicalConditionsFilter?.DietaryNeeds.filter((_, idx) => idx !== index) || [];
            props.setMedicalConditionsFilter({
                DietaryNeeds: updatedDN,
                DietaryPreferences: props.medicalConditionsFilter?.DietaryPreferences || []
            });
            return;
        } else if(type === 'DP') {
            const updatedDP = props.medicalConditionsFilter?.DietaryPreferences.filter((_, idx) => idx !== index) || [];
            props.setMedicalConditionsFilter({
                DietaryNeeds: props.medicalConditionsFilter?.DietaryNeeds || [],
                DietaryPreferences: updatedDP
            });
            return;
        }        
    }

    const appendMedical = (type: string) => {
        if(type === 'DN') {
            const updatedDN = [...props.medicalConditionsFilter?.DietaryNeeds || [], ''];
            props.setMedicalConditionsFilter({
                DietaryNeeds: updatedDN,
                DietaryPreferences: props.medicalConditionsFilter?.DietaryPreferences || []
            });
            return;
        } else if(type === 'DP') {
            const updatedDP = [...props.medicalConditionsFilter?.DietaryPreferences || [], ''];
            props.setMedicalConditionsFilter({
                DietaryNeeds: props.medicalConditionsFilter?.DietaryNeeds || [],
                DietaryPreferences: updatedDP
            });
            return;
        }        
    }

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={12} className="pt-2"><span className="misconfig-filter-subheading">Medical conditions filters</span></Col>
            </Row>                
            {props.medicalConditionsFilter?.DietaryNeeds.map((value, idx) => (
            <Row className="pb-2" key={`dietaryNeeds-${idx}`}>  
                <Col md={firstCol} className="ps-4"><b>{idx === 0 ? 'Dietary Needs' : ''}</b></Col>
                <Col md={secondCol}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Dietary Needs"
                        value={value}
                        onChange={(e) => updateMedicalValue(idx, 'DN', e.target.value)} />
                </Col>
                <Col>
                {canEditEstablishments &&
                    <button className="btn btn-light red-color" onClick={() => removeMedicalCondition(idx, 'DN')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>}
                </Col>                    
            </Row>
            ))}
             {canEditEstablishments && 
             <Row className="pb-2">
                     <Col md={firstCol} className="ps-4"><b>{props.medicalConditionsFilter?.DietaryNeeds.length === 0 ? 'Dietary Needs' : ''}</b></Col>
                     <Col md={secondCol}>
                    <button
                        type="button"
                        className="btn"
                        onClick={() => appendMedical('DN')}
                        style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Dietary Needs filter">
                        + Add New
                    </button>
                </Col>
            </Row>}
            {props.medicalConditionsFilter?.DietaryPreferences.map((value, idx) => (
            <Row className="pb-2" key={`dietaryPreferences-${idx}`}>  
                <Col md={firstCol} className="ps-4"><b>{idx === 0 ? 'Dietary Preferences' : ''}</b></Col>
                <Col md={secondCol}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Dietary Preferences"
                        value={value}
                        onChange={(e) => updateMedicalValue(idx, 'DP', e.target.value)} />
                </Col>
                <Col>
                {canEditEstablishments &&
                    <button className="btn btn-light red-color" onClick={() => removeMedicalCondition(idx, 'DP')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>}
                </Col>                    
            </Row>
            ))}
             {canEditEstablishments && 
             <Row className="pb-2">
                     <Col md={firstCol} className="ps-4"><b>{props.medicalConditionsFilter?.DietaryPreferences.length === 0 ? 'Dietary Preferences' : ''}</b></Col>
                     <Col md={secondCol}>
                    <button
                        type="button"
                        className="btn"
                        onClick={() => appendMedical('DP')}
                        style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Dietary Preferences filter">
                        + Add New
                    </button>
                </Col>
            </Row>}            
        </React.Fragment>
    );
}
